import { __read } from "tslib";
import { SupportedHostingApps } from '../configuration/runtimeDataSources';
var history = undefined;
export var parseUrls = function (urlJsonString) {
    var urlMap = new Map();
    if (urlJsonString) {
        var urls = JSON.parse(urlJsonString);
        Object.entries(urls).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            try {
                urlMap.set(SupportedHostingApps[key], new URL(value));
            }
            catch (_c) {
                // ignore if URL is not valid
            }
        });
    }
    return urlMap;
};
export function setHistory(newHistory) {
    history = newHistory;
}
export function getHistory() {
    if (history === undefined) {
        throw new Error('History object has not been set');
    }
    return history;
}
